import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SessionService, ConstantsService, CompaniesEnum } from '@app/base/core';
import { GasRequestStatusViewModel } from '@app/modules/landing';
import { ContactUsService } from '@app/shared/services/contact-us.service';

@Component({
    selector: 'app-header',
    templateUrl: './app.header.component.html',
    styleUrls: ['./app.header.component.css']
})
export class AppHeaderComponent implements OnInit {
    builderPortalHome: boolean = false;
    formData: FormGroup;
    public serviceTrackerData: GasRequestStatusViewModel = null || undefined;

    constructor(
        public constantsSvc: ConstantsService,
        public sessionSvc: SessionService,
        private route: ActivatedRoute,
        public router: Router,
        private fb: FormBuilder,
        private contactUs: ContactUsService) {
    }

    get navBrandLink() {
        return `/${this.sessionSvc.paramLdc.toLowerCase()}/${this.sessionSvc.paramLdc === CompaniesEnum.SC
            ? 'company' : 'home'}`;
    }

    ngOnInit() {
        this.route.queryParams.subscribe(params => {
            this.builderPortalHome = params['fromBuilder'] === 'true';
        });

        this.formData = this.fb.group({
            ApplicantFullName: new FormControl('', [Validators.required, Validators.maxLength(200)]),
            EmailAddress: new FormControl('', [Validators.required, Validators.pattern(this.constantsSvc.emailPattern), Validators.maxLength(150)]),
            Message: new FormControl('', [Validators.required, Validators.maxLength(500)]),
            ApplicantId: new FormControl(''),
            BcaId: new FormControl('')
        });
    }

    ngOnDestroy() {
        this.formData.reset();
    }

    redirectToContactus() {
        this.formData.reset();
        const serviceData = localStorage.getItem('serviceTrackerData');
        this.serviceTrackerData = JSON.parse(serviceData);
        $('#contact_us_modal').modal('show');
    }

    onSubmit(formData) {
        formData.ApplicantId = this.serviceTrackerData.requestId;
        formData.BcaId = this.serviceTrackerData.bcaId;
        this.contactUs.addContactUsDetails(formData)
            .subscribe(() => {
                $('#contact_us_modal').modal('hide');
                $('#contact_us_confirmation_modal').modal('show');
            }, () => {
                $('#contact_us_modal').modal('hide');
            });
    }
}
